//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const signalR = require("@microsoft/signalr");
import Cookies from "@/utils/cookie";
import { configs } from "@/configs";
import { battleRoyaleRooms, createBattleRoyaleRoom } from "@/api/battleRoyale";

export default {
  data() { return { rooms: [], busy: false, errorMessage: "", connection: null, fallbackTimer: null, lastFallbackRefresh: 0 }; },
  computed: {
    waitingRoomCount() { return this.rooms.filter(room => room.state === "Waiting").length; },
    activeRoomCount() { return this.rooms.filter(room => !["Waiting", "Finished", "Cancelled"].includes(room.state)).length; },
    highestPot() { return this.rooms.reduce((max, room) => Math.max(max, Number(room.potAmount || room.players.length * 10)), 0); },
  },
  created() { this.loadRooms(); this.connectLobby(); this.fallbackTimer = setInterval(this.refreshFallback, 3000); },
  beforeDestroy() { clearInterval(this.fallbackTimer); if (this.connection) this.connection.stop(); },
  methods: {
    unwrap(response) { return response.data && (response.data.data || response.data.Data); },
    formatCoin(value) { return Number(value || 0).toFixed(2); },
    roomStatus(room) {
      const text = { Waiting: "等待集结", Starting: "战局启动", Choosing: "舱室选择中", Resolving: "爆破程序启动", Settling: "清算奖池", Finished: "战局结束", Cancelled: "战局中止" }[room.state];
      return room.state === "Choosing" ? `第 ${room.currentRound} 轮 · ${text}` : text || room.state;
    },
    async run(action) { this.busy = true; this.errorMessage = ""; try { return await action(); } catch (error) { this.errorMessage = error.response?.data?.msg || error.message || "指令执行失败"; throw error; } finally { this.busy = false; } },
    async loadRooms() { try { this.rooms = this.unwrap(await battleRoyaleRooms()) || []; } catch (_) {} },
    async connectLobby() {
      // SignalR 负责实时刷新战区；断线期间由定时轮询兜底。
      this.connection = new signalR.HubConnectionBuilder().withUrl(`${configs.serveBaseURL.replace(/(.*)\/api/, "$1/hubs")}/BattleRoyale`, { accessTokenFactory: () => Cookies.getToken() }).withAutomaticReconnect([1000, 2000, 5000]).configureLogging(signalR.LogLevel.Error).build();
      this.connection.on("RoomsSnapshot", rooms => { this.rooms = rooms || []; });
      this.connection.onreconnected(() => this.connection.invoke("SubscribeLobby"));
      try { await this.connection.start(); await this.connection.invoke("SubscribeLobby"); } catch (_) { this.connection = null; }
    },
    async refreshFallback() { if (this.connection && this.connection.state === "Connected") return; if (Date.now() - this.lastFallbackRefresh < 2500) return; this.lastFallbackRefresh = Date.now(); await this.loadRooms(); },
    async createRoom() { const response = await this.run(() => createBattleRoyaleRoom()); const room = this.unwrap(response); this.$router.push({ name: "battleRoyaleRoom", params: { roomId: String(room.roomId) } }); },
    openRoom(roomId) { this.$router.push({ name: "battleRoyaleRoom", params: { roomId: String(roomId) } }); },
  },
};
